<div class="cancel">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.Term, langText.AreYouSure)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body">
    <p>
      {{localize(langSection.AddUserPage, langText.UserQueueCancelMessage)}}
    </p>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-green" (click)="confirmCancel()">{{localize(langSection.Term,
      langText.Yes)}}</button>
    <button type="button" class="btn btn-white" (click)="dismissModal()">{{localize(langSection.Term,
      langText.No)}}</button>
  </div>
</div>